<template>
  <div class="debugging-wrapper" :class="{ 'bg-pink-800': toggleLogging, 'right-12': mainNavStatus, 'right-0':!mainNavStatus }" v-if="debugging">

    <div class="toggle-debugging-btn open">
      <svg @click="toggleLogTxtField()" class="block w-5 h-5 cursor-pointer select-none z-120" role="button" aria-label="Open debugging area">
        <use xlink:href="#debug" />
      </svg>
    </div>

    <div class="debug-buttons-wrapper" v-if="toggleLogging && debugging">
      <div v-if="toggleLogging && debugging" class="btn-debugging btn-debugging-clear" @click="resetLogTxtField()">
        <svg class="block w-5 h-5 cursor-pointer select-none z-120" role="button" aria-label="Close debugging area">
          <use xlink:href="#cross" />
        </svg>
      </div>
      <div v-if="toggleLogging && debugging" class="btn-debugging btn-debugging-test" @click="testLogs">?</div>
      <div v-if="toggleLogging && debugging" class="btn-debugging btn-debugging-fontsize plus" @click='fontSize++'>+</div>
      <div v-if="toggleLogging && debugging" class="btn-debugging btn-debugging-fontsize minus" @click='fontSize--'>–</div>
      <div v-if="toggleLogging && debugging" class="btn-debugging btn-debugging-scroll" @click="scrollToBottom()">
        <svg class="block w-5 h-5 cursor-pointer select-none z-120" role="button" aria-label="Scroll to bottom of debugging area">
          <use xlink:href="#arrow-down" />
        </svg>
      </div>
    </div>

    <div class="debugarea" :style="{ 'font-size': fontSize + 'px' }" v-html="log" v-if="toggleLogging && debugging" ref="debugarea"></div>

  </div>
</template>

<script>
export default {
  name: 'DebuggingArea',
  data () {
    return {
      toggleLogging: false,
      debugCounter: 0,
      fontSize: 12
    }
  },
  computed: {
    debugging: {
      get () { return this.$store.getters['settings/getDebugging'] }
    },
    log: {
      get () { return this.$store.getters['settings/getLog'] },
      set (payload) { return this.$store.dispatch('settings/setLog', payload) }
    },
    mainNavStatus: {
      get () { return this.$store.getters['ui/getMainNavStatus'] },
      set (bool) { this.$store.dispatch('ui/toggleMainNavStatus', bool) }
    }
  },
  methods: {
    toggleLogTxtField () {
      this.$l.log('MapContainer: methods', 'toggleLogTxtfield invoked\nthis.toggleLogging =', this.toggleLogging)
      this.toggleLogging = !this.toggleLogging
    },
    resetLogTxtField () {
      this.$store.dispatch('settings/resetLog')
    },
    scrollToBottom () {
      this.$refs.debugarea.scrollTop = this.$refs.debugarea.scrollHeight
    },
    testLogs () {
      this.$l.log('App: testLogs', 'log: variable check: appVersion', this.appVersion)
      this.$l.info('App: testLogs', 'info: Some Info', 'more text...')
      this.$l.success('App: testLogs', 'success: OBJECT', { a: 'TEXT', b: 'Another text', c: 'Number', d: 'String' })
      this.$l.debug('App: testLogs', 'debug: function call: this.toggleCurrentGeoLocDisplay()', this.toggleCurrentGeoLocDisplay)
      this.$l.warn('App: testLogs', 'warn: function call', function () { return 1 !== 2 })
      this.$l.error('App: testLogs', 'error: function as reference this.currentGeoLocDisplayStatus', this.currentGeoLocDisplayStatus)
      this.$l.fatal('App: testLogs', 'fatal: OBJECT', { a: 'TEXT', b: 'Another text', c: 'Number', d: 'String' })
    }
  }
}
</script>

<style lang="postcss">
.debugarea::-webkit-scrollbar {
  width: 0.25rem;
  background: rgba(120, 24, 53, 1);
}

.debugarea::-webkit-scrollbar-track {
  width: 0.25rem;
  background: rgba(120, 24, 53, 1);
}

.debugarea::-webkit-scrollbar-thumb {
  width: 0.5rem;
  @apply bg-pink-400;
}

/* DEBUGGING */
.debugging-wrapper {
  @apply fixed top-0 left-0 p-2;
  @apply z-100010
}

.debugarea {
  @apply relative mt-2 mx-0;
  @apply p-1 md:p-3;
  @apply h-64 w-full md:w-128;
  @apply bg-white overflow-y-auto leading-normal rounded shadow-sm z-100000;
}

/* Toggle the debugging textarea */
.toggle-debugging-btn {
  @apply absolute top-2 right-2 p-1;
  @apply flex items-center justify-center;
  @apply text-pink-800 bg-white bg-opacity-80 rounded-full;
  @apply cursor-pointer transition z-100000;
}
.toggle-debugging-btn:hover {
  @apply text-pink-500
}

/* Other buttons */

.debug-buttons-wrapper {
  @apply relative mt-0 ml-0;
  @apply h-10 w-78  md:w-60 p-2;
  @apply flex items-center justify-between;
  @apply bg-white rounded z-100000;
}

.btn-debugging {
  @apply flex items-center justify-center;
  @apply relative rounded;
  @apply w-7 h-7;
  @apply bg-red-700 text-red-200 bg-opacity-75;
  @apply cursor-pointer select-none transition z-120
}
.btn-debugging:hover {
  @apply bg-opacity-100;
}

.btn-debugging-test,
.btn-debugging-fontsize {
  @apply font-bold;
}

/* ----- Logger classes ----- */

.info {
  @apply bg-blue-700 text-blue-100;
}
.warn {
  @apply bg-yellow-700 text-yellow-100;
}
.error {
  @apply bg-red-700 text-red-100;
}
.fatal {
  @apply bg-gray-900 text-red-200;
}
.success {
  @apply bg-green-700 text-green-100;
}
.debug {
  @apply bg-yellow-200 text-yellow-800;
}
.log {
  @apply bg-gray-200 text-gray-900;
}
</style>
